import React, { memo } from 'react';
import { RecurrenceEnum } from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/constants';
import { HrSimulation } from 'routes/HumanResourcesModule/Simulation/helpers/types';
import { useGetDetailedAgentDepartureHypotheses } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/Departure/helpers/hooks/agentDepartureHypothesis';
import { DetailedAgentDepartureHypothesis } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/Departure/helpers/types';
import AgentHypothesesResume from '../components/AgentHypothesesResume';
import DepartureHypothesesGrid from './DepartureHypothesesGrid';

type Props = {
    hrSimulation: HrSimulation;
};

const DepartureHypothesesResume = ({
    hrSimulation,
}: Props): React.ReactElement => (
    <AgentHypothesesResume
        hrSimulation={hrSimulation}
        titleKey="humanResources.simulation.departureHypothesesResume"
        useGetData={useGetDetailedAgentDepartureHypotheses}
        RecurrentGridComponent={(props: {
            data: DetailedAgentDepartureHypothesis[];
        }) => (
            <DepartureHypothesesGrid
                data={props.data}
                hrSimulation={hrSimulation}
                recurrence={RecurrenceEnum.RECURRENT}
            />
        )}
        NonRecurrentGridComponent={(props: {
            data: DetailedAgentDepartureHypothesis[];
        }) => (
            <DepartureHypothesesGrid
                data={props.data}
                hrSimulation={hrSimulation}
                recurrence={RecurrenceEnum.NON_RECURRENT}
            />
        )}
    />
);

export default memo(DepartureHypothesesResume);
